document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-toggle]');
  if (toggle) {
    const header = document.querySelector('.site-header');
    header?.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', header?.classList.contains('is-open') ? 'true' : 'false');
  }

  const tab = event.target.closest('[data-tab-button]');
  if (tab) {
    const section = tab.closest('[data-tabs]');
    if (!section) return;
    const target = tab.dataset.tabButton;
    section.querySelectorAll('[data-tab-button]').forEach((btn) => btn.classList.toggle('is-active', btn === tab));
    section.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== target;
    });
  }
});

function getProductVariants(form) {
  const script = form.querySelector('[data-product-variants]');
  if (!script) return [];
  try {
    return JSON.parse(script.textContent);
  } catch (error) {
    console.error('DQ Store: Unable to parse product variants.', error);
    return [];
  }
}

function getSelectedOptions(form) {
  const selected = [];
  form.querySelectorAll('[data-option-group]').forEach((group) => {
    const position = Number(group.dataset.optionPosition) - 1;
    const checked = group.querySelector('[data-option-input]:checked');
    if (checked) selected[position] = checked.value;
  });
  return selected;
}

function findVariant(variants, selectedOptions) {
  return variants.find((variant) =>
    variant.options.length === selectedOptions.length &&
    variant.options.every((value, index) => value === selectedOptions[index])
  );
}

function updateOptionAvailability(form, variants, selectedOptions) {
  form.querySelectorAll('[data-option-group]').forEach((group) => {
    const position = Number(group.dataset.optionPosition) - 1;

    group.querySelectorAll('[data-option-input]').forEach((input) => {
      const candidate = selectedOptions.slice();
      candidate[position] = input.value;

      const hasAvailableMatch = variants.some((variant) => {
        if (!variant.available || variant.options[position] !== input.value) return false;
        return candidate.every((value, index) => {
          if (index === position || !value) return true;
          return variant.options[index] === value;
        });
      });

      input.disabled = !hasAvailableMatch;
      const label = form.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      label?.classList.toggle('is-unavailable', !hasAvailableMatch);
    });
  });
}

function updateProductForm(form) {
  const variants = getProductVariants(form);
  if (!variants.length) return;

  const selectedOptions = getSelectedOptions(form);
  const variant = findVariant(variants, selectedOptions);

  form.querySelectorAll('[data-option-group]').forEach((group) => {
    const selected = group.querySelector('[data-option-input]:checked');
    const selectedText = group.querySelector('[data-option-selected]');
    if (selectedText && selected) selectedText.textContent = selected.value;
  });

  updateOptionAvailability(form, variants, selectedOptions);

  const idInput = form.querySelector('[data-variant-id]');
  const price = form.querySelector('[data-product-price]');
  const addButton = form.querySelector('[data-add-to-cart]');
  const addText = form.querySelector('[data-add-to-cart-text]');

  if (!variant) {
    if (idInput) idInput.value = '';
    if (price) price.innerHTML = '<span class="product-price__unavailable">Unavailable combination</span>';
    if (addButton) addButton.disabled = true;
    if (addText) addText.textContent = 'Unavailable';
    return;
  }

  if (idInput) idInput.value = variant.id;

  if (price) {
    let priceMarkup = `<span class="product-price__current">${variant.price_formatted}</span>`;
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceMarkup += `<span class="price--compare">${variant.compare_at_price_formatted}</span>`;
    }
    price.innerHTML = priceMarkup;
  }

  if (addButton) addButton.disabled = !variant.available;
  if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';

  if (variant.url && window.history?.replaceState) {
    window.history.replaceState({}, '', variant.url);
  }
}

document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-option-input]');
  if (input) {
    const form = input.closest('[data-product-form]');
    if (form) updateProductForm(form);
    return;
  }

  const select = event.target.closest('[data-product-variant-select]');
  if (!select) return;
  const form = select.closest('form');
  if (!form) return;
  const idInput = form.querySelector('input[name="id"]');
  if (idInput) idInput.value = select.value;
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach((form) => updateProductForm(form));
});
